var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-inline-flex h-pointer",class:{
         "b-back-button": !_vm.isRelativePosition,
         "b-back-button__relative": _vm.isRelativePosition
     },on:{"click":function($event){$event.stopPropagation();return _vm.goBack.apply(null, arguments)}}},[_c('FwIcon',{staticClass:"h-flex-center h-pointer",attrs:{"icon":"arrow-left","size":"14","color":"rgba(33,63,107,.3)"}}),_c('p',{staticClass:"h-bold h-mv-0 h-ml-10 h-font-14"},[_vm._v(" "+_vm._s(_vm.$t('BUTTON.BACK'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }